import React from 'react';

const InterviewExpiredPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
            <svg
              className="h-8 w-8 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            この面接は実施期限を過ぎています
          </h1>
          <p className="text-gray-600 mb-6">
            設定されていた面接可能期間が終了したため、この面接を受験することはできません。
          </p>
          <p className="text-sm text-gray-500">
            面接の再設定が必要な場合は、企業の担当者にお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};

export default InterviewExpiredPage;
